import React, { useEffect } from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { scrollToNode } from '../utils/dom';
import { usePreferences } from '../hooks/usePreferences';

import PreferencesStep0 from './PreferencesStep0';
import PreferencesStep1 from './PreferencesStep1';
import PreferencesStep2 from './PreferencesStep2';
import BlockContent from './BlockContent';
import Header from './Header';
import Loader from './Loader';
import Anchor from './Anchor';

function Preferences() {
  const { step, email, isLoading } = usePreferences();

  useEffect(() => {
    scrollToNode(`#email-preferences-scroll`);
  }, [step]);

  return (
    <>
      <Header
        header={{
          blockContent: {
            title: <Trans id="preferencesWelcomePageTitle" />
          },
          isNavbarTransparent: true
        }}
      />
      <div className="preferences section">
        <Anchor id="email-preferences-scroll" />
        <div className="wrapper">
          {!email && (
            <BlockContent
              content={{
                headingThree: <Trans id="preferencesErrorMessageTitle" />,
                description: <Trans id="preferencesErrorMessageDescription" />
              }}
            />
          )}
          {step === 0 && email && <PreferencesStep0 />}
          {step === 1 && email && <PreferencesStep1 />}
          {step === 2 && email && <PreferencesStep2 />}
        </div>
      </div>
      <Loader isLoading={isLoading} />
    </>
  );
}

export default Preferences;
